import { X, Check } from 'lucide-react';

const ANTES = ['Archivos de Excel', 'Revisión manual', 'Errores frecuentes', 'Horas perdidas'];
const DESPUES = ['Conciliación automática', 'Resultados en menos de un minuto', 'Reportes claros', 'Historial disponible en la nube'];

export default function ProblemSolution() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <h2 className="text-3xl md:text-4xl font-extrabold text-navy-900 tracking-tight">
            ¿Todavía haces conciliaciones bancarias manualmente?
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Conciliar bancos en Excel puede tomar horas, generar errores y retrasar el cierre contable.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6">
          <div className="rounded-2xl border border-red-100 bg-red-50/50 p-8">
            <p className="text-sm font-bold uppercase tracking-wide text-red-500 mb-5">Antes</p>
            <ul className="space-y-3.5">
              {ANTES.map((item) => (
                <li key={item} className="flex items-center gap-3 text-slate-700">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-red-100 text-red-500 shrink-0">
                    <X size={14} />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-2xl border-2 border-brand-green/30 bg-green-50/50 p-8 relative">
            <p className="text-sm font-bold uppercase tracking-wide text-brand-greenDark mb-5">
              Después con Conciliabanco
            </p>
            <ul className="space-y-3.5">
              {DESPUES.map((item) => (
                <li key={item} className="flex items-center gap-3 text-slate-800 font-medium">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-brand-green/15 text-brand-greenDark shrink-0">
                    <Check size={14} />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
